import axios from "axios";
import getBlogCollectionUrl from "@Pages/Blog/utils/getBlogCollectionUrl";
import { BLOG_ARTICLES_COLLECTION } from "@Pages/Blog/BlogHomeRevamp/settings";
import type { BlogCategoryOption } from "@Pages/Blog/BlogHomeRevamp/types";

type CategoryDoc = { id: number | string; name?: string; slug?: string };
type ArticleCategoryDoc = { category?: number | string | { id?: number | string } | null };

const PUBLISHED = "where[_status][equals]=published&where[isArchived][equals]=false";

const toCategoryId = (category: ArticleCategoryDoc["category"]) =>
  category && typeof category === "object" ? category.id : category;

const fetchBlogCategories = async (): Promise<BlogCategoryOption[]> => {
  const [categories, articles] = await Promise.all([
    axios.get<{ docs: CategoryDoc[] }>(
      `${getBlogCollectionUrl(
        "categories",
      )}?${PUBLISHED}&select[name]=true&select[slug]=true&limit=0`,
    ),
    axios.get<{ docs: ArticleCategoryDoc[] }>(
      `${getBlogCollectionUrl(
        BLOG_ARTICLES_COLLECTION,
      )}?${PUBLISHED}&select[category]=true&depth=0&limit=0`,
    ),
  ]);
  const used = new Set(
    (articles.data?.docs || []).map((doc) => String(toCategoryId(doc.category) ?? "")),
  );
  return (categories.data?.docs || [])
    .filter((doc): doc is Required<CategoryDoc> => !!doc.name && !!doc.slug)
    .filter((doc) => used.has(String(doc.id)))
    .map(({ id, name, slug }) => ({ id, name: name.trim(), slug }));
};

export default fetchBlogCategories;
